import { IDishGroup } from "../menu/menuTypes";
import { IOrderEntry } from "../order_history/ordersTypes";

export interface ParsedTableName {
  sector: string;
  table: string;
  isTakeAway: boolean;
  formatted: string;
}

/**
 * Parses a table name string (e.g. "rosso-12", "asporto-3", "giallo-5")
 * into sector name and table number components.
 */
export function parseTableName(tableName: string | undefined): ParsedTableName {
  if (!tableName || tableName.trim() === "") {
    return { sector: "N/D", table: "", isTakeAway: false, formatted: "N/D" };
  }

  const trimmed = tableName.trim();
  const lower = trimmed.toLowerCase();
  const isTakeAway = lower.startsWith("asporto") || lower.startsWith("venerd");

  const dashIndex = trimmed.indexOf("-");
  if (dashIndex > -1) {
    const sectorPart = trimmed.substring(0, dashIndex).trim();
    const tablePart = trimmed.substring(dashIndex + 1).trim();

    return {
      sector: sectorPart.toUpperCase(),
      table: tablePart,
      isTakeAway,
      formatted: `SETTORE: ${sectorPart.toUpperCase()} - TAVOLO: ${tablePart}`,
    };
  }

  return {
    sector: trimmed.toUpperCase(),
    table: "",
    isTakeAway,
    formatted: trimmed.toUpperCase(),
  };
}

/**
 * Determines whether an order is a takeaway (asporto / venerdì) order.
 */
export function isOrderTakeAway(
  order: IOrderEntry,
  menu: IDishGroup[]
): boolean {
  if (!order) return false;

  const lowerTable = (order.table_name || "").toLowerCase();
  if (lowerTable.startsWith("asporto") || lowerTable.startsWith("venerd")) {
    return true;
  }

  if (order.order_lines && order.order_lines.length > 0) {
    const allDishes = menu.flatMap((category) => category.dishes);
    return order.order_lines.some((line) => {
      const dish = allDishes.find((d) => d.id === line.dish_id);
      return (
        dish?.is_take_away === 1 ||
        (dish?.is_take_away as unknown as boolean) === true
      );
    });
  }

  return false;
}
